import React, { useState, useEffect } from 'react';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { db, auth } from '../FirebaseComp/firebase';
import jsPDF from 'jspdf';
import './promotions.css';

function Promotions() {




  return (
    <>
      <section className="hero">
        <div className="hero-image">
          <img src="/logo192.png" alt="conference" />
        </div>
        <div className="hero-content">
          <h1>Chavo Tours & Taxi</h1>
          <p>Welcome to Chavo Tours, your premier choice for taxi and tour services in Sri Lanka. 
            We offer reliable, safe, and affordable transportation for both tourists and locals. 
            Book your ride today for the best travel experience.</p>
        </div>
      </section>

<div className="apc-promotions">
  <h2 className="apc-promotions-title">Current Promotions</h2>

  {/* Example: No promotions */}
  <div className="apc-no-promotions">
    <p>No promotions available at the moment.</p>
    <span>Book your first ride to unlock exclusive offers.</span>
  </div>
  </div>

    </>
  );
}

export default Promotions;